// Global trigger so Command Bar can open the DEFCON override dialog from anywhere
let _opener: ((level: number) => void) | null = null;
export const registerDefconDialogOpener = (fn: (level: number) => void) => { _opener = fn; };
export const openDefconDialog = (level: number) => { _opener?.(level); };
